// @ts-check
import { getRenderOptions } from '~/contentstack/rendering';
// @ts-ignore - We are moving this file on build - this import will be visible upon completion.
import { Stack } from './CsSdk';

export const DefaultRenderOptions = getRenderOptions();

/**
 * Fetches specific queries for a Content Type.
 * @function
 * @template {import('~/contentstack/types').BaseT} Props
 * @param {import('~/contentstack/types').UsePreviewOnModelOptions<Props>} options
 * @returns {Promise<Props>}
 */
export async function getEntryByUid({ contentType, contentUid, referenceFieldPaths = [] }) {
	const specificQuery = Stack.ContentType(contentType).Query();

	if (referenceFieldPaths.length > 0) {
		specificQuery.includeReference(...referenceFieldPaths);
	}

	try {
		const result = await specificQuery.toJSON().where('uid', contentUid).find();
		return result[0][0];
	} catch (err) {
		console.error('Error getting content by ID:', err);
	}
}
